import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import PermissionWrapper from '../auth/PermissionWrapper';
import LandingAdmin from '../components/LandingAdmin/LandingAdmin';
import LandingDefault from '../components/LandingDefault/LandingDefault';

class Home extends React.Component {

    render = () => {
        this.props.info('Home.js/render');
        return (
            <Container>
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Default Home Page">
                    <LandingDefault  {...this.props} {...this.state} />
                </PermissionWrapper>
                <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Admin Home Page">
                    <LandingAdmin  {...this.props} {...this.state} />
                </PermissionWrapper>
            </Container>
        )
    }
}

export default Home;